import React from 'react';

import styled from 'styled-components';

import UserManagementAddUserButton from './create/UserManagementAddUserButton';
import UserManagementFilters from './filters/UserManagementFilters';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const UserManagementControls = () => {
  return (
    <Container>
      <UserManagementFilters />
      <UserManagementAddUserButton />
    </Container>
  );
};

export default UserManagementControls;
